export default "__VITE_ASSET__DNANVHj9__"